





















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import DealItem from '@/components/deal/DealItem.vue'
import CardItem from '@/components/home/CardItem.vue'
import eventModule from '@/store/event'
import dealModule from '@/store/deal'
import homeModule from '@/store/home'
import { Deal, DealMedia } from '@/types/Deal'
import { AddressLocation, Category } from '@/types/Types'
import { DealType } from '@/utils/enums'
import { Card } from '@/types/Card'
import DealFilter from './DealFilter.vue'

@Component({
  components: {
    DealItem,
    CardItem,
    DealFilter
  }
})
export default class DealGrid extends Vue {
  @Prop() readonly deals?: Deal[]
  @Prop() readonly cards?: Card[]
  @Prop() readonly hideMap?: boolean
  @Prop() readonly title?: string
  @Prop() readonly type?: string

  private get hasNoDeals() {
    return (
      this.filteredDeals &&
      this.filteredDeals.length === 0 &&
      (!this.filteredCards || this.filteredCards.length === 0)
    )
  }

  private get loading() {
    return eventModule.loading
  }

  private get showDealMap(): boolean {
    return (
      !(this.filteredDeals?.length === 0 && this.filteredCards?.length > 0) &&
      this.dealType === DealType.LOCAL &&
      !this.hideMap
    )
  }

  private get formattedDealType(): string {
    if (this.dealType === DealType.LOCAL) {
      return 'lokalen Deals'
    }

    return 'Onlineshop Deals'
  }

  private get searchTerm(): string {
    return eventModule.searchTerm || ''
  }

  private get filters() {
    return eventModule.filters
  }

  private get filteredDeals(): Deal[] {
    const baseDeals = this.deals || dealModule.deals
    if (
      this.searchTerm.trim().length === 0 &&
      Object.entries(this.filters).length === 0
    ) {
      return baseDeals
    }
    return baseDeals.filter(el => {
      for (const filterField in this.filters) {
        const filterValue = this.filters[filterField]
        const filterValues = filterValue

        let found = filterValues.length <= 0
        singleFieldLoop: for (const currentFilterValue of filterValues) {
          const field =
            el[
              filterField as keyof Deal &
                keyof typeof dealModule.possibleFilters
            ]

          for (const val of field) {
            if (val._id === currentFilterValue) {
              // einer gefunden => Wert ist true
              found = true
              break singleFieldLoop
            }
          }
        }
        if (!found) return false
      }

      return true
    })
  }

  private get filteredCards(): Card[] {
    if (this.searchTerm.trim().length === 0) {
      return this.cards || []
    }
    return []
  }

  private get filteredLocations(): AddressLocation[] {
    if (this.dealType !== DealType.LOCAL) return []
    const locations: any[] = []
    if (this.filteredDeals) {
      if (this.filteredDeals.length === 0) return []
      for (const deal of this.filteredDeals) {
        for (const venue of deal.venues) {
          locations.push({ location: venue.address.location, dealId: deal._id }) // Tried concat. That caused some sync problems i think
        }
      }
    }
    return locations
  }

  private get dealType(): string {
    if (this.type) return this.type
    else return dealModule.type
  }

  @Watch('dealType')
  private async fetchDeals(): Promise<void> {
    eventModule.setLoading(true)
    await dealModule.fetchAll()
    eventModule.setLoading(false)
  }

  private async created() {
    await this.fetchDeals()
    if (!dealModule.bookmarks) {
      await dealModule.fetchBookmarks()
    }
  }

  private async setDeal(currentDeal: Deal): Promise<void> {
    await dealModule.setDeal(currentDeal)
    this.$router.push({
      name: 'DealDetail',
      params: { id: currentDeal._id }
    })
  }
}
